const animateDuration = 500;

$('[data-behaviour="scroll-to"]').each(function() {
    const href = $(this).attr('href');
    if (!$(href).length) {
        $(this).remove();
    }
});

$('[data-behaviour="scroll-to"]').on('click', function (e) {
    e.preventDefault();

    const scrollTarget = $(this).attr('href');
    const header = $('.c-site-header');

    if ($(scrollTarget).length > 0) {
        const scrollPosition = $(scrollTarget).offset().top - header.height();

        $('html, body').animate({
            scrollTop: scrollPosition
        }, animateDuration);
    }
});
